module.exports = __webpack_public_path__ + "img/clue_router.8696a2cf.png";